import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { LicenseService } from 'src/app/services/license/license.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-edit-subscription-license-route',
  templateUrl: './edit-subscription-license-route.component.html',
  styleUrls: ['./edit-subscription-license-route.component.css']
})
export class EditSubscriptionLicenseRouteComponent extends BaseComponent implements OnInit {
  customer_id;
  updateRouteForm: FormGroup;
  getCompanyobj: any = [];
  licenseObj: any = [];
  actionOptions = ['view', 'add', 'edit', 'delete', 'execute'];
  submitted = false;
  route_id: string;
  selectedCompany: string;
  routeObj: any;
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private licenseService: LicenseService,
    private masterService: MasterService
  ) { super(); }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    this.updateRouteForm = this.formBuilder.group({
      selectedCompany: [(this.customer_id == 0) ? '' : this.customer_id, Validators.required],
      license_id: ['', Validators.required],
      full_route: ['', [Validators.required, Validators.maxLength(500)]],
      component_name: ['', Validators.maxLength(200)],
      action: ['view', Validators.required],
      also_in_licenses: ['', Validators.maxLength(200)],
      component_file: ['', Validators.maxLength(500)],
      source_file: ['', Validators.maxLength(500)]
    });
    if (localStorage.getItem('edit_subscription_license_route_id')) {
      this.route_id = localStorage.getItem('edit_subscription_license_route_id');
      this.selectedCompany = localStorage.getItem('edit_subscription_license_route_company_id');
      this.loadLicenses(this.selectedCompany);
      this.masterService.getLicenseRouteById(this.selectedCompany, this.route_id).subscribe(response => {
        if (response.status) {
          this.routeObj = response.data;
          this.dataBinding();
        } else {
          this.toastrService.error(response.message || 'License route not found');
        }
      });
    }
  }
  getCompany() {
    const self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self);
    }, error => {
      console.log(error);
    });
  }
  loadLicenses(companyId) {
    if (!companyId) {
      this.licenseObj = [];
      return;
    }
    this.licenseService.gettingLicense(companyId).subscribe(data => {
      if (data.status && data.data) {
        this.licenseObj = data.data;
      } else {
        this.licenseObj = [];
      }
    }, error => {
      console.log(error);
      this.licenseObj = [];
    });
  }
  get f() { return this.updateRouteForm.controls; }
  dataBinding() {
    this.updateRouteForm.patchValue({
      selectedCompany: this.selectedCompany,
      license_id: this.routeObj && this.routeObj.license_id ? String(this.routeObj.license_id) : '',
      full_route: this.routeObj && this.routeObj.full_route,
      component_name: (this.routeObj && this.routeObj.component_name) || '',
      action: (this.routeObj && this.routeObj.action) || 'view',
      also_in_licenses: (this.routeObj && this.routeObj.also_in_licenses) || '',
      component_file: (this.routeObj && this.routeObj.component_file) || '',
      source_file: (this.routeObj && this.routeObj.source_file) || ''
    });
  }
  updateRoute() {
    this.submitted = true;
    if (this.updateRouteForm.invalid) {
      return;
    }
    const { selectedCompany } = this.updateRouteForm.value;
    this.ngxSpinnerService.show();
    this.masterService.updateLicenseRoute(selectedCompany, this.route_id, this.updateRouteForm.value).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status) {
        this.toastrService.success('License route updated successfully');
        this.router.navigateByUrl('/corporate/subscription-license-route-list');
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error.message);
    });
  }
}
